/* eslint-disable import/extensions */
import * as React from 'react';
import { useState, useEffect, ReactElement } from 'react';
import { Keyboard, Navigation } from 'swiper';
import { Swiper, SwiperSlide, useSwiperSlide } from 'swiper/react';

import '../css/swiper.scss';
import '../css/virtual.scss';
import '../css/navigation.scss';

import '../css/campfire-carousel.sass';

export interface CampfireCarouselProps {
  children: ReactElement[];
  onChange?: Function;
  id?: string;
  autoPlaySpeed?: string;
  dragThreshold?: string;
}

const Slide = (props: { child: ReactElement }) => {
  const slide = useSwiperSlide();
  return React.cloneElement(props.child, {
    expandable: false,
    focusable: slide.isActive,
    centeredCarousel: true,
  });
};

export default function CampfireCarousel(props: CampfireCarouselProps) {
  const { dragThreshold = '20' } = props;
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  const filteredChildren: ReactElement[] =
    props.children?.filter(
      // @ts-ignore
      (el: ReactElement) => !el?.type?.toString().includes('fragment')
    ) || [];

  useEffect(() => {
    const listener = () => setScreenSize(window.innerWidth);
    window.addEventListener('resize', listener);

    return () => window.removeEventListener('resize', listener);
  }, []);

  let keyIndex = 0;

  return (
    <div
      id={props.id ? props.id : 'campfire-carousel'}
      className="campfire-carousel"
      role="application"
      aria-label="carousel"
    >
      <Swiper
        threshold={parseInt(dragThreshold, 10)}
        modules={[Navigation, Keyboard]}
        slidesPerView={screenSize < 768 ? 1.2 : 1.8}
        spaceBetween={screenSize < 768 ? screenSize / 15 : screenSize / 15}
        navigation={!(screenSize < 768)}
        loop
        pagination={{ clickable: true }}
        keyboard={{ enabled: true }}
        slideDuplicateActiveClass="swiper-slide-duplicate"
        centeredSlides={!(screenSize < 768)}
        autoplay={
          props.autoPlaySpeed
            ? { delay: parseInt(props.autoPlaySpeed, 10) }
            : false
        }
        onAfterInit={(swiper) => {
          if (
            swiper.navigation &&
            swiper.navigation.nextEl &&
            swiper.navigation.prevEl
          ) {
            // eslint-disable-next-line no-param-reassign
            swiper.navigation.nextEl.title = 'Next slide';
            // eslint-disable-next-line no-param-reassign
            swiper.navigation.prevEl.title = 'Previous slide';
          }
        }}
        onSlideChange={(slider) => {
          if (props.onChange) {
            props.onChange(slider.realIndex);
          }

          if (
            slider?.slides[
              slider.previousIndex
              // @ts-ignore
            ]?.firstChild?.innerHTML?.includes(
              document.activeElement?.innerHTML
            )
          ) {
            // eslint-disable-next-line no-unused-expressions
            document.getElementsByClassName('swiper-slide')[
              slider.activeIndex
              // @ts-ignore
            ]?.firstChild?.focus();
          }
        }}
      >
        {filteredChildren.map((child) => {
          keyIndex += 1;
          return (
            <SwiperSlide key={keyIndex}>
              <Slide child={child} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}
